<template>
    <div class="individual-search-inner-container">

        <ais-instant-search  :search-client="searchClient" :index-name="algoliaPrefix + 'SITE'">
            <ais-autocomplete>
              <template #default="{ currentRefinement, indices, refine }"><div>

                  <form action="/site-search/" method="get" class="navbar-form form-inline form-closed" id="main-search-form">
                    <div class="search-icon"><img src="/wp-content/themes/regionalhealth/assets/images/icons/icon-search-white.svg" alt=""></div>
                    <input class="form-control" id="main-search-input" name="query" value="" type="search" placeholder="" aria-label="Search">
                    <input type="submit" class="search-submit-button" value="Search">
                </form>

                <template v-if="currentRefinement">
                <div v-for="index in indices" :key="index.indexId">
    <!--                      <li>-->
    <!--                        <h3>{{ index.indexName }}</h3>-->
                    <ul>
                      <li v-for="hit in index.hits" :key="hit.objectID">
                        <ais-highlight attribute="name" :hit="hit"/>
                      </li>
                    </ul>
    <!--                      </li>-->
                </div>
                </template>
              </div></template>
        </ais-autocomplete>
        </ais-instant-search>

    </div>
</template>

<script>
    import algoliasearch from 'algoliasearch/lite';

    const algoliaPrefix = (window.ajax_global && window.ajax_global.algolia_prefix) ? window.ajax_global.algolia_prefix : 'prod_';

    export default {

    // props: ['query_in'],

    data() {
        return {
            // query: '',
            algoliaPrefix,
            searchClient: algoliasearch(
                'O4J2BVWP7X',
                '25e82b9ff49bfc98eeaea844742d9654',
            ),
            // initialUiState: {
            //     prod_JOBS: {
            //         query: this.query_in,
            //         refinementList: ["active:true"]
            //     },
            // },
            // searchParameters: {
            //     hitsPerPage: 20
            // },
            // monthNames: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
            // showingFilters: false
        }
    },

    mounted() {

        // this.query = this.query_in;
        //
        // this.$nextTick(function () {
        //
        // });

    },

    components: {},

    watch:{},

    methods: {

    }

}
</script>
